'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _H = require('../elements/headings/H4');

var _H2 = _interopRequireDefault(_H);

var _UIResultsMessage = require('../results/UIResultsMessage');

var _UIResultsMessage2 = _interopRequireDefault(_UIResultsMessage);

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

var _illustrationName = require('../utils/propTypes/illustrationName');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var errorTypes = {
  badRequest: {
    image: 'errors/icecream',
    title: function title() {
      return _I18n2.default.text('ui.UIErrorMessage.badRequest.title');
    }
  },
  error: {
    image: 'errors/icecream',
    title: function title() {
      return _I18n2.default.text('ui.UIErrorMessage.error.title');
    }
  },
  expired: {
    image: 'errors/hourglass',
    title: function title() {
      return _I18n2.default.text('ui.UIErrorMessage.expired.title');
    }
  },
  notFound: {
    image: 'errors/map',
    title: function title() {
      return _I18n2.default.text('ui.UIErrorMessage.notFound.title');
    }
  }
};

var errors = _extends({}, errorTypes, {
  '400': errorTypes.badRequest,
  '403': errorTypes.expired,
  '404': errorTypes.notFound,
  '500': errorTypes.error
});

var ErrorBody = function ErrorBody(props) {
  return _react2.default.createElement(_UIResultsMessage2.default.defaultProps.Body, _extends({}, props, {
    className: 'private-error-msg__body'
  }));
};

var ErrorImage = function ErrorImage(props) {
  return _react2.default.createElement(_UIResultsMessage2.default.defaultProps.Image, _extends({}, props, {
    className: 'private-error-msg__image'
  }));
};

var getErrorValues = function getErrorValues(type) {
  return errors[type] || errors.error;
};

var defaultIllustrationProps = { width: 175 };

var renderTitle = function renderTitle(title) {
  return _react2.default.isValidElement(title) ? title : _react2.default.createElement(
    _H2.default,
    { className: 'private-error-msg__title' },
    (0, _lazyEval2.default)(title)
  );
};

exports.default = _react2.default.createClass({
  displayName: 'UIErrorMessage',

  propTypes: {
    Body: _react.PropTypes.func,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    illustration: (0, _illustrationName.getIllustrationNamePropType)(),
    illustrationProps: _react.PropTypes.object,
    title: (0, _createLazyPropType2.default)(_react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.string])),
    type: _react.PropTypes.oneOf(Object.keys(errors))
  },

  getDefaultProps: function getDefaultProps() {
    return {
      Body: ErrorBody,
      illustrationProps: defaultIllustrationProps,
      type: 'error'
    };
  },
  render: function render() {
    var _props = this.props,
        Body = _props.Body,
        children = _props.children,
        className = _props.className,
        illustration = _props.illustration,
        illustrationProps = _props.illustrationProps,
        title = _props.title,
        type = _props.type,
        rest = _objectWithoutProperties(_props, ['Body', 'children', 'className', 'illustration', 'illustrationProps', 'title', 'type']);

    var _getErrorValues = getErrorValues(type),
        image = _getErrorValues.image,
        imageTitle = _getErrorValues.title;

    return _react2.default.createElement(
      _UIResultsMessage2.default,
      _extends({}, rest, {
        Body: Body,
        className: (0, _reactUtils.classNames)('private-error-msg', className),
        illustration: illustration || image,
        illustrationProps: illustrationProps,
        Image: ErrorImage,
        title: renderTitle(title || imageTitle)
      }),
      children
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/error/UIErrorMessage.js
// module id = 496
// module chunks = 0